import { Box, Flex, Stack } from "@chakra-ui/react";
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import React from "react";

function SidebarContent(props) {
  const { routes, openDropdown, toggleDropdown } = props;

  return (
    <Flex direction="column" height="100%" pt="20px" px="12px" pb="24px">
      <Brand />
      <Stack direction="column" spacing="2px" mb="auto" mt="4px">
        <Box>
          <Links routes={routes} openDropdown={openDropdown} toggleDropdown={toggleDropdown} />
        </Box>
      </Stack>
    </Flex>
  );
}

export default SidebarContent;
